import axios from './axios'
import { WebQuoteDTO } from './dto/webQuote.dto'

class WebQuoteServiceClass {
  async list () {
    const res = await axios.get<WebQuoteDTO>('/api/web/quotes')
    return res.data
  }

  async create (quote: WebQuoteDTO) {
    const res = await axios.post<WebQuoteDTO>('/api/web/quotes', quote)
    return res.data
  }

  async update (quote: WebQuoteDTO) {
    const res = await axios.put<WebQuoteDTO>(`api/web/quotes/${quote.id}`, quote)
    return res.data
  }

  delete (quote: WebQuoteDTO) {
    return axios.delete<WebQuoteDTO>(`api/web/quotes/${quote.id}`)
  }
}

const WebQuoteService = new WebQuoteServiceClass()

export {
  WebQuoteService
}
